import { render } from "./memoryControl.vue?vue&type=template&id=5014f1de"
import script from "./memoryControl.vue?vue&type=script&lang=js"
export * from "./memoryControl.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__